import React from "react";
import Head from 'next/head';
import { Navbar } from "./Navbar";
import Footer from "./footer/Footer";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import FloatingButtons from "./FloatingButton";

const DefaultLayout: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    return (
        <div className="browser-frame">
            <Head>
                <meta key="meta-charset" charSet="utf-8" />
                <meta key="meta-viewport" name="viewport" content="width=device-width, initial-scale=1" />
                <link key="favicon" rel="icon" href="/images/IIT-Challenge-Logo-2025.png" />
                <title>IIT Challenge 2026</title>
            </Head>
            <Navbar />
            <div className="row relative mt-24 mb-3">
                <main>
                    {children}
                </main>
            </div>
            <FloatingButtons />
            <Footer />
        </div>
    );
}
export const WithDefaultLayout = (page: React.ReactElement) => <DefaultLayout>{page}</DefaultLayout>;
